import { ImpactType } from '../impact';
import { VatRate } from '../invoicing';
import type { ProjectGroupImpactType } from '../projects/project-groups';

export enum AdminTreeType {
  DEFAULT = 'DEFAULT',
  REFERRAL = 'REFERRAL',
  REFERRED = 'REFERRED',
  WITH_SIGN = 'WITH_SIGN',
}

export enum InvoiceProvider {
  STRIPE = 'STRIPE',
  XERO = 'XERO',
}

export const InvoiceProviders = Object.values(InvoiceProvider);

export type AddTreesRequestBody = {
  numTrees: number;
  treeNames: string[];
  username: string;
  projectId?: number;
  treeType?: AdminTreeType;
};

export type AddImpactRequestBody = {
  impactType: string;
  amount: number;
  username: string;
  projectId?: number;
  name?: string;
};

export type AdminSalesAgentRequestBody = {
  customerId: number;
  salesAgentIds: number[];
};

export type MoveImpactRequestBody = {
  toUsername: string;
  fromUsername: string;
  impactId?: string;
};

export type CreateUserSubscriptionRequestBody = {
  addons: object[];
  shortCode: string;
  userId: string;
};

export type SyncBadgesRequestBody = {
  userId: string;
};

export type GetImpactReportCsvRequestBody = {
  apiOnly: boolean;
  impactTypes: ImpactType[];
  startDate: string;
  endDate: string;
  userId: string;
  accessToken?: string;
};

export type ProjectsResponseBody = {
  _id: string;
  isActive: boolean;
  impactType: ProjectGroupImpactType;
  updatedAt: string;
  projects: {
    id: number;
    name: string;
    split: number;
    _id: string;
  }[];
  __v: number;
};

export interface CarbonOffsetProject {
  id: number;
  split: number;
}

export type AddProjectGroupRequestBody = {
  projects: CarbonOffsetProject[];
  impactType: ProjectGroupImpactType;
};

export type CreateSubforestsRequestBody = {
  childUsernames: string[];
  parentUsername: string;
};

// list of new child endpoints, e.g. ecologi.com/parent/child
export type CreateSubforestsResponseBody = { childLinks: string[] };

export interface InvoiceTile {
  quantity: number;
  fundedBy?: string;
  recipientEmail?: string;
  groupId?: number;
}

export type CreateInvoiceLineItem = ProjectLineItem | ImpactFundLineItem;

interface BaseInvoiceLineItem {
  unitPrice: number;
  quantity: number;
  fundedBy?: string;
  groupId?: number;
  vatRate: VatRate;
  discountAmount?: number;
  tiles?: InvoiceTile[];
}

export interface ProjectLineItem extends BaseInvoiceLineItem {
  projectId: number;
}

export interface ImpactFundLineItem extends BaseInvoiceLineItem {
  impactFundId: number;
}

export interface CreateInvoiceRequestBody {
  idempotencyKey: string;
  provider: InvoiceProvider;
  crmDealId: string;
  customerId: number;
  lineItems: Array<CreateInvoiceLineItem>;
  daysUntilDue: number;
  poNumber?: string;
  taxCode?: string;
  recipientEmails?: string[];
}

export interface CreateInvoiceResponseBody {
  processorId: string | null;
}

export interface FinaliseInvoiceRequestBody {
  provider: InvoiceProvider;
  invoiceId: string;
}

export const MAX_ADMIN_INVOICE_LINE_ITEMS = 100;

export const MAX_RECIPIENT_EMAILS = 10;

export interface XeroRecipientEmailsResponseBody {
  recipientEmails: string[];
}
